export const MAINTENANCE_PAGE_VALIDATION = {
    title: {
        required: 'Title wajib diisi',
    },
    description: {
        required: 'Description wajib diisi',
    },
    image_url: {
        required: 'Image wajib diisi',
    },
}
